export class PageableRequest {
    size: number;
    page: number;
    filters: Map<string, string>;
    orders: Map<string, string>;


    constructor(data?: Partial<PageableRequest>) {
        if (data) {
            this.bindData(data);
        }
    }

    bindData(data: Partial<PageableRequest>): void {
        if (data) {
            this.size = data.size;
            this.page = data.page;
            this.filters = data.filters;
            this.orders = data.orders;
        }
    }

    getRequestBody(): PageableRequest {
        return {
            ...this,
            filters: (this.filters?Object.fromEntries(this.filters):null),
            orders: (this.orders?Object.fromEntries(this.orders):null)
        };

    }
}
